import type { InsuranceProduct, InsuranceProductVersion } from '../../model/model.ts'

import type { FrAupaPolicyItem, FrAupaPolicyItemsState } from './fr-aupa-insurance.ts'
import type { FrAupaPricingVersion } from './fr-aupa-pricing-versions.ts'
import type {
  FrAupaActivitiesConfigVersionFormat,
  FrAupaBaseName,
  FrAupaProductVersionFormat,
  FrAupaProductVersionPrefix,
  FrAupaStaticFileIdFormat,
} from './model.ts'
import { frAupaPolicyItems_v1_0_0 } from './v1_0_0/policy-items.ts'
import { frAupaStaticFilesIds_v1_0_0 } from './v1_0_0/static-files.ts'

export const frAupaProductVersions = [
  /**
   * Initial version
   */
  'product-fr-aup-axa-1.0.0-2026-09-08',
] as const satisfies FrAupaProductVersionFormat[]

export type FrAupaProductVersion = (typeof frAupaProductVersions)[number]

type FrAupaInsuranceProductVersion = InsuranceProductVersion<
  FrAupaProductVersionPrefix,
  FrAupaBaseName,
  FrAupaProductVersion,
  FrAupaPolicyItem,
  FrAupaStaticFileIdFormat,
  FrAupaPricingVersion,
  FrAupaActivitiesConfigVersionFormat,
  FrAupaPolicyItemsState
>

type FrAupaInsuranceProduct = InsuranceProduct<
  FrAupaProductVersionPrefix,
  FrAupaBaseName,
  FrAupaProductVersion,
  FrAupaPolicyItem,
  FrAupaStaticFileIdFormat,
  FrAupaPricingVersion,
  FrAupaActivitiesConfigVersionFormat,
  FrAupaPolicyItemsState
>

export const frAupaProduct_v1_0_0 = {
  version: 'product-fr-aup-axa-1.0.0-2026-09-08',
  description: 'Initial version of FR-AUPA product',
  policyItems: frAupaPolicyItems_v1_0_0,
  staticFilesId: [...frAupaStaticFilesIds_v1_0_0],
  pricingVersion: ['pricing-fr-aup-axa-1.0.0-2026-09-08'],
  // Required by the product model but never read: the AUPA configuration per activity lives in the activity
  // config's versionedProductConfigurations, resolved by product version.
  activitiesConfigVersion: 'activities-config-fr-aup-axa-1.0.0-2026-09-08',
} as const satisfies FrAupaInsuranceProductVersion

export const frAupaProduct = {
  id: 'fr-aupa',
  versions: {
    'product-fr-aup-axa-1.0.0-2026-09-08': frAupaProduct_v1_0_0,
  },
} as const satisfies FrAupaInsuranceProduct
export type FrAupaProduct = typeof frAupaProduct
